export { default as Account } from './Account'
export { default as Page } from './PageSetting'
export { default as Security } from './Security'
export { default as Billings } from './Billings'
export { default as Language } from './Language/Language'
